import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';

const Permissions = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [permission, setPermission] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentPermissionId, setCurrentPermissionId] = useState(null);
  
  // Sample permissions data
  const [permissions, setPermissions] = useState([
    { id: 1, title: "View Dashboard", status: "Active" },
    { id: 2, title: "Manage Users", status: "Active" },
    { id: 3, title: "Edit Settings", status: "Inactive" },
  ]);

  // Error state
  const [errors, setErrors] = useState({
    permission: ""
  });

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      permission: ""
    };
  
    if (!permission.trim()) {
      newErrors.permission = "Permission title is required";
      valid = false;
    } else if (permission.length < 3) {
      newErrors.permission = "Name must be at least 3 characters.";
      valid = false;
    }
  
    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      if (isEditing) {
        // Update existing permission
        setPermissions(permissions.map(p => 
          p.id === currentPermissionId ? { ...p, title: permission } : p
        ));
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 5000);
      } else {
        // Add new permission
        const newPermission = {
          id: permissions.length + 1,
          title: permission,
          status: "Active"
        };
        setPermissions([...permissions, newPermission]);
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 5000);
      }
      resetForm();
      setShowSidebar(false);
    }
  };

  const handleEdit = (id) => {
    const permissionToEdit = permissions.find(p => p.id === id);
    if (permissionToEdit) {
      setPermission(permissionToEdit.title);
      setIsEditing(true);
      setCurrentPermissionId(id);
      setShowSidebar(true);
    }
  };

  const resetForm = () => {
    setPermission("");
    setIsEditing(false);
    setCurrentPermissionId(null);
    setErrors({ permission: "" });
  };

  // Check for mobile view
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebar = document.querySelector('.sidebar-container');
      if (showSidebar && sidebar && !sidebar.contains(event.target)) {
        const addButton = document.querySelector('.add-role-button');
        if (addButton && !addButton.contains(event.target)) {
          setShowSidebar(false);
          resetForm();
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSidebar]);

  return (
    <main className="main-content relative">

      {/* Success Message Popup */}
      {showSuccess && (
        <div className="fixed top-4 right-4 z-50 animate-fade-in">
          <div className="bg-[#635BFF] text-white px-4 py-2 rounded-lg shadow-lg flex items-center">
            <span className="material-symbols-outlined mr-2">check_circle</span>
            {isEditing ? "Permission Updated Successfully!" : "Permission Updated Successfully!"}
          </div>
        </div>
      )}

      {/* Dark overlay when sidebar is open */}
      {showSidebar && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
          onClick={() => {
            setShowSidebar(false);
            resetForm();
          }}
        />
      )}

      {/* Main Content */}
      <div className={`transition-all duration-300 ${showSidebar ? '' : ''}`}>
        <div className="mb-6 flex flex-wrap items-center justify-between ml-4">
          <h2 className="text-xl font-semibold text-gray-800 ">
            Permissions
          </h2>

          <nav>
            <ol className="flex items-center gap-1.5 mr-7">
              <li>
                <Link
                  className="inline-flex items-center gap-1.5 text-sm text-black "
                  to="/dashboard"
                >
                  Home /
                </Link>
              </li>
              <li className="text-sm text-gray-800 ">
              Permissions
              </li>
            </ol>
          </nav>
        </div>

        <div className="mx-auto p-4 md:p-4">
          <div className="space-y-5 sm:space-y-6">
            <div className="rounded-2xl border border-gray-200 bg-white ">
              <div className="px-5 py-4 sm:px-6 sm:py-5">
                <h3 className="text-base font-medium text-gray-800 ">
                  <div className="flex justify-end">
                    <button 
                      className="add-role-button bg-[#635BFF] text-white px-4 py-2 rounded-lg shadow-lg hover:bg-[#4a28aa] transition"
                      onClick={() => {
                        setShowSidebar(true);
                        resetForm();
                      }}
                    >
                      Add Permissions
                    </button>
                  </div>
                </h3>
              </div>
              
              <div className="p-2 sm:p-5 border-t border-gray-100 ">
                <div className="overflow-hidden rounded-xl border border-gray-200 bg-white ">
                  <div className="max-w-full overflow-x-auto">
                    <table className="min-w-full">
                      <thead>
                        <tr
                          className="text-white border-b border-gray-100  whitespace-nowrap"
                          style={{ backgroundColor: "#635BFF" }}
                        >
                          <th className="px-3 py-2 sm:px-5 sm:py-3">
                            <div className="flex items-center justify-center">
                              <p className="font-medium text-white text-xs sm:text-sm ">
                                SI.No
                              </p>
                            </div>
                          </th>
                          <th className="px-3 py-2 sm:px-5 sm:py-3">
                            <div className="flex items-center justify-center">
                              <p className="font-medium text-white text-xs sm:text-sm ">
                                Title
                              </p>
                            </div>
                          </th>
                          <th className="px-3 py-2 sm:px-5 sm:py-3">
                            <div className="flex items-center justify-center">
                              <p className="font-medium text-white text-xs sm:text-sm ">
                                Status
                              </p>
                            </div>
                          </th>
                          <th className="px-3 py-2 sm:px-5 sm:py-3">
                            <div className="flex items-center justify-center">
                              <p className="font-medium text-white text-xs sm:text-sm ">
                                Update
                              </p>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100 ">
                        {permissions.map((perm, index) => (
                          <tr key={perm.id} className="whitespace-nowrap">
                            <td className="px-3 py-2 sm:px-5 sm:py-4">
                              <div className="flex items-center justify-center">
                                <p className="text-black text-xs sm:text-sm ">
                                  {index + 1}
                                </p>
                              </div>
                            </td>
                            <td className="px-3 py-2 sm:px-5 sm:py-4">
                              <div className="flex items-center justify-center">
                                <p className="text-black text-xs sm:text-sm ">
                                  {perm.title}
                                </p>
                              </div>
                            </td>
                            <td className="px-3 py-2 sm:px-5 sm:py-4">
                              <div className="flex items-center justify-center">
                                <button className={`rounded-full px-2 py-0.5 text-xs sm:text-sm font-medium text-white ${
                                  perm.status === "Active" ? "bg-[#047A48]" : "bg-[#DC2626]"
                                }`}>
                                  {perm.status}
                                </button>
                              </div>
                            </td>
                            <td className="px-3 py-2 sm:px-5 sm:py-4">
                              <div className="flex items-center justify-center">
                                <button 
                                  className="rounded-full bg-[#635BFF] px-3 py-0.5 text-xs sm:text-sm font-medium text-white"
                                  onClick={() => handleEdit(perm.id)}
                                >
                                  Edit
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Right Sidebar */}
      {showSidebar && (
        <div className={`sidebar-container fixed top-0 right-0 h-full bg-white shadow-lg z-50 transition-all duration-300 transform translate-x-0
          ${isMobile ? 'w-full max-w-sm' : 'w-96'}`}>
          <div className="h-full flex flex-col p-6">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-lg font-semibold text-gray-800">
                {isEditing ? "Edit Permission" : "Add New Permission"}
              </h3>
              <button 
                onClick={() => {

                  setShowSidebar(false);
                  resetForm();
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <hr></hr>
            
            <form onSubmit={handleSubmit} className="flex-1 flex flex-col mt-5">
              <div className="mb-4">
                <label className="block text-m font-medium text-gray-700 mb-2">
                Permission Title<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  className={`w-full p-2 border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm ${
                    errors.permission ? 'border-[#DC2626] focus:ring-[#DC2626]' : 'focus:ring-[#635BFF]'
                }`} 
                value={permission}
                onChange={(e) => setPermission(e.target.value)}
                placeholder="Enter your Permission Title"  
                maxLength="100"
                />
                {errors.permission && <p className="mt-1 text-sm text-red-500">{errors.permission}</p>}
              </div>

              <div className="mt-auto">
                <div className="flex space-x-3">
                  <button
                    type="submit"
                    className="w-full bg-[#635BFF] text-white py-2 px-4 rounded-md hover:bg-[#4a28aa] transition"
                  >
                    {isEditing ? "Update" : "Submit"}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setShowSidebar(false);
                      resetForm();
                    }}
                    className="w-full bg-gray-200 text-gray-800 py-2 px-4 rounded-md hover:bg-gray-300 transition"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </main>
  );
};

export default Permissions;